export default function KnowledgeCheckIcon() {
    return (
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.35" cx="28" cy="28" r="28" fill="#26BCD7"/>
            <path d="M28 40C34.6274 40 40 34.6274 40 28C40 21.3726 34.6274 16 28 16C21.3726 16 16 21.3726 16 28C16 34.6274 21.3726 40 28 40Z" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23.5786 28.633L26.7372 32.4215L33.6843 24.843" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    )
}